import * as actionTypes from '../actions/actionTypes';

export default function newEntities(state = [], action) {
  switch(action.type){
    case actionTypes.NEW_ENTITIES: {
      return action.entities;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/newEntities.js